export default {
  header: "But what IS Monster Maker, anyways?",
  view: "about"
};
